export const ADULT = 'ADT';
export const CHILD = 'CHD';
export const INFANT = 'INF';
export const GROUP = 'GROUP';
